import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { ResponseModel } from '@core/api';
import { SettingsModel } from '@core/api/model/settingsModel';



@Injectable()
export class SettingsService {

  public configuration = new Configuration();
  public defaultHeaders = new HttpHeaders();
  protected basePath = 'https://localhost/v1';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   * Returns a list of settings
   */
  public settingsGet(): Observable<ResponseModel<SettingsModel[]>> {
    return this.httpClient.get<ResponseModel<SettingsModel[]>>(`${ this.basePath }/settings`);
  }

  /**
   * Save settings
   * @param body SettingsModel
   */
  public settingsPut(body: SettingsModel[]): Observable<ResponseModel<SettingsModel[]>> {
    return this.httpClient.put<ResponseModel<SettingsModel[]>>(`${ this.basePath }/settings`, body);
  }

}
